import type * as React from 'react';
import { cn } from '@/shared/lib/cn';

export function BreadcrumbItem({ className, ...props }: React.ComponentProps<'li'>) {
  return (
    <li data-slot="breadcrumb-item" className={cn('inline-flex items-center gap-1', className)} {...props} />
  );
}
